import { ScheduleChecklistRequest } from "../api/ChecklistApi";
import { FormState } from "../component/ScheduleForm";
import { ChecklistScheduleDto, ScheduleType } from "../model/ChecklistDtos";
import { DateService } from "../../../core/service/dateService";
import { scheduleFrequencyConverter } from "../service/scheduleFrequencyConverter";

export const useChecklistScheduleMapper = () => {
    function toDto(schedule: ChecklistScheduleDto): Partial<FormState> {
        return {
            idChecklist: schedule.idChecklist,
            idChecklistSchedule: schedule.idChecklistSchedule,
            onceDate: schedule.onceDate,
            startDate: schedule.startDate,
            endDate: schedule.endDate,
            enableRepeat: schedule.type !== ScheduleType.Once,
            repeatType: schedule.type ?? ScheduleType.Once,
            repeatOnDayDaily: scheduleFrequencyConverter.bitmaskToDays(schedule.dailyFrequency),
            repeatOnDayWeekly: schedule.weeklyFrequency,
            repeatOnMonths: scheduleFrequencyConverter.bitmaskToMonthsEnum(schedule.monthlyFrequencyMonth),
            repeatOnWeekdayOnMonths: (schedule.monthlyFrequencyDay === undefined ||
                !schedule.monthlyFrequencyDay) &&
                schedule.monthlyFrequencyOn !== undefined &&
                schedule.monthlyFrequencyOnDay !== undefined,
            monthlyFrequencyDay: scheduleFrequencyConverter.bitmaskToMonthlyDays(schedule.monthlyFrequencyDay),
            monthlyOnWeekDays: scheduleFrequencyConverter.bitmaskToOns(schedule.monthlyFrequencyOn),
            monthlyFrequencyOnWeekDay: scheduleFrequencyConverter.bitmaskToDays(schedule.monthlyFrequencyOnDay)
        }
    }

    function toRequest(formState: Partial<FormState>) : ScheduleChecklistRequest|undefined {
        const idChecklist = formState.idChecklist;

        if (!idChecklist) return undefined
        if (!formState.startDate) return undefined
        if (!formState.repeatType) return undefined

        const startDate = !!formState.startDate ? DateService.formatLocalDate(new Date(formState.startDate)) : DateService.formatLocalDate(new Date())
        const onceDate = !!formState.onceDate ? DateService.formatLocalDate(new Date(formState.onceDate)) : DateService.formatLocalDate(new Date())
        const endDate = !!formState.endDate ? DateService.formatLocalDate(new Date(formState.endDate)) : undefined

        return {
            idChecklistSchedule: formState.idChecklistSchedule,
            idChecklist: idChecklist,
            type: formState.repeatType,
            startDate: startDate,
            endDate: endDate,
            onceDate: onceDate,
            dailyFrequency: formState.repeatOnDayDaily || [],
            weeklyFrequency: formState.repeatOnDayWeekly || 0,
            monthlyFrequencyMonth: formState.repeatOnMonths || [],
            monthlyFrequencyDay: formState.monthlyFrequencyDay || [],
            monthlyFrequencyOn: formState.monthlyOnWeekDays || [],
            monthlyFrequencyOnDay: formState.monthlyFrequencyOnWeekDay || [],
        }
    }

    return { toDto, toRequest }
}